import { CsvButton } from '@components/Buttons/CsvButton';
import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { INovosInadimplentesFilter, INovosInadimplentesRecord } from '@services/RelatorioService';
import React from 'react';

export type NovosInadimplentesTableProps = {
    data: IData<INovosInadimplentesRecord, INovosInadimplentesFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function NovosInadimplentesTable ({ data, onCsvButtonClick, isLoading }: NovosInadimplentesTableProps) {
    const formatter = useFormatter();

    return (
        <React.Fragment>
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="clienteId">Cliente ID</TableSortCell>
                        <TableSortCell fieldName="nome">Cliente</TableSortCell>
                        <TableSortCell fieldName="cpf">CPF</TableSortCell>
                        <TableSortCell fieldName="totalInadimplente">Total Inadimplente</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((novosInadimplentesRecord, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{novosInadimplentesRecord.clienteId}</TableKeyCell>
                                    <TableCell><LinkText to={`/cliente/${novosInadimplentesRecord.clienteId}`} text={novosInadimplentesRecord.nome} /></TableCell>
                                    <TableCell>{novosInadimplentesRecord.cpf}</TableCell>
                                    <TableCell>{formatter.toFloat(novosInadimplentesRecord.totalInadimplente)}</TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                </TableBody>
            </TableNoResult>
        </React.Fragment>
    )
}